import { median } from '../../helpers/median'

type CurrencyValue = {
  usd: number
  value: number
}

type CurrencyWithValues = {
  values: CurrencyValue[] | null
  usd?: number
  value?: number
}

export type CurrencyMedians = {
  medianUsd: number
  medianGame: number
  validValuesCount: number
}

/**
 * Calculates median USD and game values from currency value wrappers
 * Filters out invalid values and returns both medians along with count of valid values
 */
export function calculateCurrencyMedians(values: CurrencyValue[]): CurrencyMedians {
  const validValues = values.filter(
    (item) => item.usd != null && item.value != null && !isNaN(Number(item.usd)) && !isNaN(Number(item.value)) && Number(item.usd) > 0 && Number(item.value) > 0
  )

  if (validValues.length === 0) {
    return {
      medianUsd: 0,
      medianGame: 0,
      validValuesCount: 0,
    }
  }

  const usdValues = validValues.map((item) => Number(item.usd))
  const gameValues = validValues.map((item) => Number(item.value))

  return {
    medianUsd: median(usdValues),
    medianGame: median(gameValues),
    validValuesCount: validValues.length,
  }
}

/**
 * Gets all currency values from either a single currency or array of currencies
 * Handles format (usd/value on object) and format (values array)
 */
export function getAllCurrencyValues(currency?: CurrencyWithValues, currencies?: CurrencyWithValues[]): CurrencyValue[] {
  if (currency) {
    // Handle format: usd and value directly on currency object
    if (currency.usd != null && currency.value != null && (!currency.values || currency.values.length === 0)) {
      return [{ usd: currency.usd, value: currency.value }]
    }
    // Handle format: values array
    return currency.values || []
  }

  if (currencies) {
    return currencies.flatMap((c) => {
      if (c.usd != null && c.value != null && (!c.values || c.values.length === 0)) {
        return [{ usd: c.usd, value: c.value }]
      }
      return c.values || []
    })
  }

  return []
}
